<template>
    <div
        v-if="state && 'show' in state"
        class="snackbar"
        :class="{
            'snackbar--static': 'static' in state,
            'snackbar--active': state.show,
            'snackbar--big': state.size === 'big',
            'snackbar--success': state.status.toLowerCase() === 'success',
            'snackbar--danger': state.status.toLowerCase() === 'error',
            'snackbar--warning': state.status.toLowerCase() === 'warning',
            'snackbar--arrow-top-right': state.arrow === 'top-right',
        }"
        @click="onClick"
        @mouseenter="mouseEnter"
        @mouseleave="mouseLeave"
    >
        <div
            class="snackbar__main"
            :class="{
                'snackbar__main--double': state.main_message !== '',
            }"
        >
            <span v-if="'icon' in state && state.icon" class="snackbar__main__icon"
                ><span class="icon-alert"></span
            ></span>
            <span v-if="'main_message' in state" class="snackbar__main__title">{{ state.main_message }}</span>
            <!-- eslint-disable vue/no-v-html -->
            <span class="snackbar__main__txt" v-html="state.message"></span>
        </div>

        <div v-if="state.btnText && state.btnText.length > 0" class="snackbar__actions">
            <button v-if="state.secBtnText" class="btn btn--border btn--small" @click="secBtnClickEvent">
                {{ state.secBtnText }}
            </button>
            <button class="btn btn--border btn--small" @click="clickEvent">{{ state.btnText }}</button>
        </div>
    </div>
</template>

<script>
    import { reactive, ref, watch } from 'vue';
    import { useStore } from 'vuex';
    import { setSnackbar } from '@/helpers';
    import Confetti from 'vue-confetti/src/confetti.js';

    export default {
        props: {
            timeoutDelay: {
                type: Number,
                required: false,
                default: 3750,
            },
            state: {
                type: Object,
                required: false,
            },
        },
        setup(props) {
            const store = useStore();
            const confetti = reactive(new Confetti());

            let onClick;

            // eslint-disable-next-line vue/no-setup-props-destructure
            const { state, timeoutDelay } = props;
            const { static: staticBar } = state || {};
            const hover = ref(false);

            const mouseEnter = () => {
                hover.value = true;
            };
            const mouseLeave = () => {
                hover.value = false;
            };

            if (!staticBar) {
                let timeout;
                const setHoverTimeout = (delay) => {
                    if (!state.message) {
                        return;
                    }

                    timeout = setTimeout(() => {
                        const snackbar = setSnackbar(state || {});
                        // Trigger a fade animation before clearing the snackbar
                        snackbar.message = null;
                        store.dispatch('GlobalStore/SET_SNACKBAR', snackbar, { root: true });

                        setTimeout(() => {
                            store.commit('GlobalStore/CLEAR_SNACKBAR', null, { root: true });
                        }, 500);
                    }, delay);
                };
                setHoverTimeout(state.delayTime ?? timeoutDelay);

                onClick = () => {
                    hover.value = false;
                    setHoverTimeout(10);
                };

                watch(hover, (hovering) => {
                    if (hovering && timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    } else if (!hovering) {
                        setHoverTimeout(500);
                    }
                });
            }

            if (props && props.state && props.state.confetti) {
                confetti.start({
                    defaultDropRate: 5,
                    defaultSize: 5,
                    particlesPerFrame: 0.5,
                    defaultColors: ['#F6CBD4', '#2c9de2', '#39add1', '#4fc8b4', '#ffe9b7', '#68cfbc'],
                });

                setTimeout(() => {
                    confetti.stop();
                }, 1000);
            }

            const clickEvent = () => {
                if ('btnHref' in props.state) {
                    props.state.btnHref();
                }
            };

            const secBtnClickEvent = () => {
                if ('secBtnHref' in props.state) {
                    props.state.secBtnHref();
                }
            };

            const getRandomInteger = (min, max) => {
                min = Math.ceil(min);
                max = Math.floor(max);

                return Math.floor(Math.random() * (max - min)) + min;
            };

            return {
                clickEvent,
                secBtnClickEvent,
                getRandomInteger,
                mouseEnter,
                mouseLeave,
                onClick,
            };
        },
    };
</script>
<style scoped lang="scss">
    .snackbar__actions {
        gap: 16px;
    }
</style>
